export function range(count: number): number[];
export function range(start: number, end: number): number[];
export function range(startOrCount: number, end?: number): number[] {
  let count: number;
  let start = 0;
  if (!end) {
    count = startOrCount;
  } else {
    count = end - startOrCount + 1;
    start = startOrCount;
  }

  return [...Array(count).keys()].map(n => n + start);
}
